const validateNumber = (rule, value, callback) => {
    if (!value) {
        return callback(new Error(rule.message));
    }
    if (isNaN(value)) {
        return callback(new Error(rule.message));
    }
    if (Number(value) <= 0) {
        return callback(new Error(rule.message));
    }
    return callback();
}

export {
    validateNumber
}

